<template>
  <div v-if="data.length != 0 ">
    <vs-table :data="data">
      <template slot="thead">
        
        <th class="qb-sticky">{{ $t('category') }}</th>
        <th class="qb-sticky" :style="{textAlign:'right'}">{{ $t('total') }} MXN</th>
        <th class="qb-sticky" :style="{textAlign:'right'}">{{ $t('total') }} USD</th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td :style="{ width: '50vw' }" class="text-left">{{ tr.CategoryName }}</vs-td>
          <vs-td :style="{ width: '25vw' }" class="text-right">{{ tr.TotalMXN }}</vs-td>
          <vs-td :style="{ width: '25vw' }" class="text-right">{{ tr.TotalUSD }}</vs-td>

          <template class="expand-user" slot="expand">
            <vs-table :data="tr.expenses">
              <template slot="thead">
                <th class="qb-sticky" :style="{textAlign:'left'}">{{ $t('vendor') }}</th>
                <th class="qb-sticky" :style="{textAlign:'center'}">{{ $t('account_number') }}</th>
                <th class="qb-sticky" :style="{textAlign:'center'}">{{ $t('folio') }}</th>
                <th class="qb-sticky" :style="{textAlign:'center'}">{{ $t('date') }}</th>
                <th class="qb-sticky" :style="{textAlign:'right'}">{{ $t('total') }}</th>
              </template> 

              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(tr, i) in data">
                  <vs-td :style="{ width: '45vw' }" class="text-left">{{ tr.VendorName }}</vs-td>
                  <vs-td :style="{ width: '20vw' }" class="text-center">{{ tr.AccountNumber }}</vs-td>
                  <vs-td :style="{ width: '10vw' }" class="text-center">{{ tr.Folio }}</vs-td>
                  <vs-td :style="{ width: '10vw' }" class="text-center">{{formatDate(tr.ExpenseDate)}}</vs-td>
                  <vs-td :style="{ width: '15vw' }" class="text-right">{{`${tr.Total} ${tr.CurrencyId}`}}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </vs-tr>
        <vs-tr v-show="data.length == 0 ">
          <vs-td colspan="6" class="text-center">
            <p colspan="6" class="text-center">{{ loadingMessage }}</p>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
  <div v-else>
    <p colspan="6" class="text-center">{{ loadingMessage }}</p>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Array,
      default: () => [{}],
    },
    loadingMessage: {
      type: String,
      default: 'Cargando...'
    }
  },
}
</script>